import type { IntakeDraft, StepId } from "../types";
export type NudgeId = "faceRef" | "action" | "multiRef" | "complexScene" | "commercial";

const has = (b: { text: string; refs: string[] }) => b.text.trim().length > 0 || b.refs.length > 0;

export function pickNudge(d: IntakeDraft, step: StepId): NudgeId | null {
  const chars = d.characters.slice(0, d.characterCount);
  const candidates: [NudgeId, boolean][] =
    step === "characters" ? [
      ["faceRef", chars.some((c) => c.look.refs.length === 0)],
      ["action", chars.some((c) => !has(c.action))],
      ["multiRef", chars.every((c) => c.look.refs.length === 1)],
      ["complexScene", d.backgroundType === "complex" && d.sceneRefs.length === 0],
    ] : step === "scene" ? [
      ["commercial", d.usageType === "commercial"],
    ] : [];
  return candidates.find(([id, ok]) => ok && !d.dismissedNudges.includes(id))?.[0] ?? null;
}
